import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid,
  Box,
} from "@mui/material";

import CHLogo from "assets/images/CH_logo.svg";
import { useAuth } from "../../hooks/useAuth";
import { QRCodeCanvas } from "qrcode.react";
import ViewBuyProduct from "components/Modal/Pawn/View/ViewBuyItems";

const InvoiceForm = ({ data }) => {
  console.log("display new data ", data);
  const rowsPerPage = 9;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [productData, setProductData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { user } = useAuth();
  const calculateTotalAmount = (products) => {
    return products.reduce((total, product) => {
      return total + (parseFloat(product.total_price) || 0);
    }, 0);
  };

  // useEffect(() => {
  // const intervalId = setInterval(() => {
  //   setCurrentDate(new Date());
  // }, 1000); // Update every second
  // return () => clearInterval(intervalId);
  // }, []);

  useEffect(() => {
    if (data) {
      // Collect products based on the numbered suffix in data keys
      const products = [];
      const productCount = Object.keys(data).reduce((max, key) => {
        const match = key.match(/_(\d+)$/);
        if (match) {
          const number = parseInt(match[1], 10);
          return Math.max(max, number);
        }
        return max;
      }, 0);

      // Group fields for each product together
      for (let i = 1; i <= productCount; i++) {
        const product = {
          product_id: data[`product_id_${i}`],
          product_code: data[`product_code_${i}`],
          product_name: data[`product_name_${i}`],
          category_id: data[`category_id_${i}`],
          detail: data[`detail_${i}`],
          blemishes: data[`blemishes_${i}`],
          size: data[`size_${i}`],
          total_amount: data[`total_amount_${i}`],
          price: data[`price_${i}`],
          total_price: data[`total_price_${i}`],
          images: data[`images_${i}`],
          notes: data[`notes_${i}`],
        };
        products.push(product);
      }

      setProductData(products);
    }
  }, []);

  // Function to split the productData into boxes of rowsPerPage
  const splitIntoBoxes = (data, rowsPerPage) => {
    let boxes = [];
    for (let i = 0; i < data.length; i += rowsPerPage) {
      boxes.push(data.slice(i, i + rowsPerPage));
    }
    return boxes;
  };

  // Prepare the boxes using the filtered product data
  const boxes = splitIntoBoxes(productData, rowsPerPage);
  useEffect(() => {
    // ใช้ useEffect เพื่อคำนวณและอัพเดท totalAmount ทุกครั้งที่ boxes เปลี่ยนแปลง
    const newTotalAmount = boxes.reduce((total, boxData) => {
      return total + calculateTotalAmount(boxData);
    }, 0);

    setTotalAmount(newTotalAmount); // อัพเดท totalAmount ใน state
  }, [boxes]);

  return (
    <>
      {boxes.map((boxData, boxIndex) => (
        <Box
          key={boxIndex}
          p={5}
          mb={2}
          border={1}
          bgcolor={"background.paper"}
          borderColor="grey.300"
          borderRadius={2}
          height={"727px"}
          width={"738px"}
          position="relative"
        >
          {/* Header Information */}
          <Grid container mb={1}>
            {/* Left Section */}
            <Grid item xs={8}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <img
                    src={CHLogo}
                    alt="รูปภาพโรงรับจำนำ"
                    style={{ height: "50px", width: "50px" }}
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography style={{ fontSize: "10px" }} fontWeight="bold">
                    {user?.company_name}
                  </Typography>
                  <Typography style={{ fontSize: "10px" }}>
                    {user?.alley +
                      " " +
                      user?.road +
                      " " +
                      user?.company_address +
                      " " +
                      user?.zipcode}
                  </Typography>
                </Grid>

                <Grid container mt={1}>
                  <Grid item xs={3}>
                    <Typography
                      // style={{fontSize:"10px"}}
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      ชื่อ-นามสกุล:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.fullName || ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      ที่อยู่:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.address || ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      เบอร์โทรศัพท์:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.phoneNumber || ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      เลขบัตรประชาชน:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.idCardNumber || ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* Right Section */}
            <Grid item xs={4} textAlign="left">
              <Box
                style={{
                  backgroundColor: "rgba(0, 187, 159, 20%)", // Opacity for the background only
                  padding: "10px",
                  textAlign: "center",
                  border: "solid 1px #00BB9F", // Border remains fully opaque
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              >
                <Typography variant="h6" style={{ color: "#00BB9F" }}>
                  ใบเสร็จรับเงิน
                </Typography>
                <Typography style={{ fontSize: "10px" }}>
                  เลขที่ XXXXXXXXXXXXX
                </Typography>
              </Box>
              <Box>
                <Grid container item>
                  <Grid item xs={4}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      วันที่ทำรายการ
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Grid item xs={8}>
                      <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                        {currentDate.toLocaleDateString()}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          {/* Table */}
          <TableContainer
            component={Paper}
            sx={{
              mt: 2,
              border: "2px solid #00BB9F",
              borderRadius: "20px",
              width: "100%", // Adjust this as per your needs
              padding: 0,
            }}
          >
            <Table sx={{ width: "100%" }}>
              <TableHead
                sx={{
                  "& .MuiTableCell-root": {
                    // Targets all TableCell components within TableBody
                    padding: "5px", // Adjust padding as needed
                  },
                }}
              >
                <TableRow>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px", paddingLeft: "5px" }}>
                      รายการซื้อ
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px" }}>{""}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px" }}>รหัส1</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px" }}>รหัส2</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px" }}>
                      ราคา/ต่อหน่วย
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px" }}>จำนวน</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px" }}>ส่วนลด</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "10px" }}>มูลค่ารวม</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                sx={{
                  "& .MuiTableCell-root": {
                    // Targets all TableCell components within TableBody
                    padding: "5px", // Adjust padding as needed
                  },
                }}
              >
                {boxData.map((product, index) => (
                  <TableRow key={product.product_id}>
                    <TableCell
                      sx={{
                        borderBottom: "none",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {index + 1 + boxIndex * rowsPerPage}.
                      </Typography>
                      {product.product_code ? (
                        <QRCodeCanvas
                          value={product.product_code} // ดึงค่าจาก formik และใช้ค่าที่ว่างเป็นค่า default ถ้าไม่พบ
                          size={40} // ขนาดของ QR Code
                          bgColor={"#ffffff"} // สีพื้นหลัง
                          fgColor={"#000000"} // สีของ QR Code
                          level={"H"} // ระดับการกู้คืนข้อมูล (L, M, Q, H)
                        />
                      ) : (
                        <div
                          style={{
                            marginLeft: "10px",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#e0e0e0",
                          }}
                        >
                          QR
                        </div>
                      )}
                    </TableCell>

                    <TableCell
                      sx={{
                        borderBottom: "none",
                        verticalAlign: "top",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        {product.product_name || "-"}
                      </Typography>
                      <Typography sx={{ fontSize: "8px" }}>
                        {product.detail || "-"}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderBottom: "none",
                        verticalAlign: "top",
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
                        {product.product_code || "-"}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderBottom: "none",
                        verticalAlign: "top",
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
                        {product.product_code_com || "-"}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderBottom: "none",
                        verticalAlign: "top",
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
                        {product.price || 0}
                        บาท
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderBottom: "none",
                        verticalAlign: "top",
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
                        {product.total_amount || 1}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderBottom: "none",
                        verticalAlign: "top",
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
                        {product.promotions || "-"}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderBottom: "none",
                        verticalAlign: "top",
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
                        {(
                          parseFloat(product.price || 0) *
                          parseFloat(product.total_amount || 1)
                        ).toLocaleString()}{" "}
                        บาท
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Box count display (e.g., "1/3", "2/3") */}
          <Typography
            style={{
              fontSize: "10px",
              position: "absolute",
              bottom: "10px",
              right: "10px",
            }}
          >
            {boxIndex + 1}/{boxes.length <= 2 ? boxes.length + 1 : boxes.length}
          </Typography>
        </Box>
      ))}
      <Box
        p={5}
        mb={2}
        border={1}
        bgcolor={"background.paper"}
        borderColor="grey.300"
        borderRadius={2}
        height={"727px"}
        width={"738px"}
        position={"relative"}
      >
        <Grid container mt={2}>
          {/* Header Information */}
          <Grid container mb={1}>
            {/* Left Section */}
            <Grid item xs={8}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <img
                    src={CHLogo}
                    alt="รูปภาพโรงรับจำนำ"
                    style={{ height: "50px", width: "50px" }}
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography style={{ fontSize: "10px" }} fontWeight="bold">
                    {user?.company_name}
                  </Typography>
                  <Typography style={{ fontSize: "10px" }}>
                    {user?.alley +
                      " " +
                      user?.road +
                      " " +
                      user?.company_address +
                      " " +
                      user?.zipcode}
                  </Typography>
                </Grid>

                {/* Customer Details */}
                <Grid container mt={1}>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      ชื่อ-นามสกุล:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.fullName || ""}
                    </Typography>
                  </Grid>

                  <Grid item xs={3}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      ที่อยู่:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.address}
                    </Typography>
                  </Grid>

                  <Grid item xs={3}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      เบอร์โทรศัพท์:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.phoneNumber}
                    </Typography>
                  </Grid>

                  <Grid item xs={3}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      เลขบัตรประชาชน:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                      {data?.idCardNumber}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* Right Section */}
            <Grid item xs={4} textAlign="left">
              <Box
                style={{
                  backgroundColor: "rgba(0, 187, 159, 0.2)", // Opacity for the background only
                  padding: "10px",
                  textAlign: "center",
                  border: "solid 1px #00BB9F", // Border remains fully opaque
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              >
                <Typography variant="h6" style={{ color: "#00BB9F" }}>
                  ใบเสร็จรับเงิน
                </Typography>
                <Typography style={{ fontSize: "10px" }}>
                  เลขที่ XXXXXXXXXXXXX
                </Typography>
              </Box>
              <Grid container>
                <Grid item xs={4}>
                  <Typography
                    style={{
                      color: "#00BB9F",
                      fontWeight: "bold",
                      fontSize: "10px",
                    }}
                  >
                    วันที่ทำรายการ
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography style={{ fontWeight: 500, fontSize: "10px" }}>
                    {currentDate.toLocaleDateString()}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Payment Information */}
          <Grid container xs={12} sx={{ mt: 10 }}>
            <Grid
              item
              xs={6}
              container
              justifyContent="center"
              alignItems="center"
            >
              <Typography align="center" style={{ fontSize: "10px" }}>
                ชำระเงินโดย :{" "}
                {data?.payment_channel ? data.payment_channel.id : "เงินสด"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Grid container justifyContent="flex-end">
                <Grid item xs={6}>
                  <Typography align="right" style={{ fontSize: "10px" }}>
                    รวม
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography align="right" style={{ fontSize: "10px" }}>
                    {totalAmount.toLocaleString()} บาท
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Summary Information */}
          <Grid
            container
            xs={12}
            sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}
          >
            <Grid item xs={6}>
              <Grid container justifyContent="flex-end">
                <Grid item xs={6}>
                  <Typography
                    align="right"
                    style={{ fontSize: "10px", fontWeight: "bold" }}
                  >
                    รวมจำนวนเงินรายการซื้อทั้งสิ้น
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    align="right"
                    style={{ fontSize: "10px", fontWeight: "bold" }}
                  >
                    {totalAmount.toLocaleString()}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Footer */}
          <Box
            sx={{
              mt: 10,
              border: "1px solid #00BB9F",
              borderRadius: "12px",
              width: "100%",
            }}
          >
            <Grid container sx={{ height: "100%" }}>
              {/* Column 1 */}
              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "1px solid #00BB9F",
                  padding: "10px",
                }}
              >
                {/* Top Divider Line */}
                <Box
                  sx={{
                    width: "100%",
                    borderTop: "1px solid #B0B0B0",
                    mb: 1,
                    mt: 5,
                  }}
                />
                <Typography align="center" style={{ fontSize: "12px" }}>
                  ลูกค้า (ผู้ซื้อ)
                </Typography>
                <Typography align="center" style={{ fontSize: "10px" }}>
                  {currentDate.toLocaleDateString()}
                </Typography>
              </Grid>

              {/* Column 2 */}
              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "1px solid #00BB9F",
                  padding: "10px",
                  height: "100%", // Ensure the column takes full height
                }}
              >
                {/* Top Divider Line */}
                <Box
                  sx={{
                    width: "100%",
                    borderTop: "1px solid #B0B0B0",
                    mb: 1,
                    mt: 5,
                  }}
                />
                <Typography align="center" style={{ fontSize: "12px" }}>
                  ร้านค้า (ซื้อ)
                </Typography>
                <Typography align="center" style={{ fontSize: "10px" }}>
                  {currentDate.toLocaleDateString()}
                </Typography>
              </Grid>

              {/* Column 3 */}
              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px",
                  height: "100%", // Ensure the column takes full height
                }}
              >
                {/* Top Divider Line */}
                <Box
                  sx={{
                    width: "100%",
                    borderTop: "1px solid #B0B0B0",
                    mb: 1,
                    mt: 5,
                  }}
                />
                <Typography align="center" style={{ fontSize: "12px" }}>
                  ผู้อนุมัติ
                </Typography>
                <Typography align="center" style={{ fontSize: "10px" }}>
                  {currentDate.toLocaleDateString()}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Box count display (e.g., "1/3", "2/3") */}
        <Typography
          style={{
            fontSize: "10px",
            position: "absolute",
            bottom: "10px",
            right: "10px",
          }}
        >
          {boxes.length <= 2
            ? boxes.length + 1 + "/" + (boxes.length + 1)
            : "3/3"}
        </Typography>
      </Box>
    </>
  );
};

export default InvoiceForm;
